import { render, staticRenderFns } from "./Z-1_Switch-Language-Country.vue?vue&type=template&id=2e9f6cef&scoped=true&"
import script from "./Z-1_Switch-Language-Country.vue?vue&type=script&lang=js&"
export * from "./Z-1_Switch-Language-Country.vue?vue&type=script&lang=js&"
import style0 from "./Z-1_Switch-Language-Country.vue?vue&type=style&index=0&id=2e9f6cef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f6cef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
